// @module TavanoTeamStaging.MadeToOrder.MadeToOrder
define("TavanoTeamStaging.MadeToOrder.Shopping.PDP.View", [
  "tavanoteamstaging_madetoorder_pdp.tpl",
  "TavanoTeamStaging.MadeToOrder.Shopping.AddedToCart.View",
  "Backbone"
], function (
  tavanoteamstaging_madetoorder_pdp_tpl,
  MadeToOrderShoppingAddedToCartView,
  Backbone
) {
  "use strict";

  // @class TavanoTeamStaging.MadeToOrder.MadeToOrder.View @extends Backbone.View
  return Backbone.View.extend({
    template: tavanoteamstaging_madetoorder_pdp_tpl,

    initialize: function (options) {
      var self = this;
      this.container = options.container;
      this.itemInfo = options.pdp.getItemInfo();

      var layout = this.container.getComponent('Layout');
      layout.addChildView('TTMadeToOrder.disclaimerMessage', function() {
        return new MadeToOrderShoppingAddedToCartView({
          container: self.container,
          itemInfo: self.itemInfo,
          disclaimerMessage: options.disclaimerMessage
        });
      });
    }
  });
});
